import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./Header.css";
// import logo from '../../assets/url_shortner.png'
class Header extends Component {
  render() {
    return (
        <nav className='Header' >
          <div class="nav-wrapper LINK">
            <a href="http://similoluwaodeyemi.com" class="brand-logo title right">
              {/* <img className='Header_img' src={logo} alt='Logo' /> */}
              <p className='title' >URL SHORTNER</p>
              {/* URL SHORTNER */}
            </a>

            <ul id="nav-mobile" class="LINK">
              <Link to='/'> Home </Link>
              <Link to='/analytics'> Analytics </Link>
             </ul>
          </div>
        </nav>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/header/Headers.js